module.exports = __webpack_public_path__ + "media/images/smart_phone/icons/img_exclamation-0663ccce04bcb6d11737170fdc63aa8a.png";